import * as browser from "webextension-polyfill";
import { getInfoCommand } from "../shared";
import { datasetKey, nodeId } from "./info-injector.types";
function getDocumentReference() {
    return window.document;
}
async function getInfo() {
    return await browser.runtime.sendMessage({ command: getInfoCommand });
}
function createInfoElement(document, info) {
    const element = document.createElement("div");
    element.id = nodeId;
    element.style.display = "none";
    element.textContent = info;
    return element;
}
async function injectInfo() {
    const document = getDocumentReference();
    const info = JSON.stringify(await getInfo());
    const element = createInfoElement(document, info);
    document.addEventListener("DOMContentLoaded", () => {
        document.body.appendChild(element);
    });
    document.documentElement.dataset[datasetKey] = info;
}
function start() {
    void injectInfo();
}
start();
